import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionRegistryOptionWithQuestionState extends ConditionRegistryCategory {
    label = 'Antwortoption kombiniert';
    constructor(parent) {
        super(parent);
        super.init();
    }
    option_canbeselected = () => new ConditionRegistryItem({
        parent: this,
        label: 'Antwortoption gerade auswählbar (Frage wird derzeit beantwortet)',
        eval: ({ option, question }) => !!option && !!question && option.isNotSelected && question.answeringState.isInAnsweringState
    });
}
